import { Component, OnInit } from '@angular/core';
import { ErrorResponse } from 'src/app/models/error-response';
import { ErrorService } from '../../services/error/error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  error!: ErrorResponse;

  constructor( private errorService: ErrorService) { }

  ngOnInit(): void {
    this.error = this.errorService.error; 
  }

}
